var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoPencil = function SvgIcoPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EEE",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m29.203 19.778 9.02 9.02-15.35 15.348a1.37 1.37 0 0 1-.633.359l-9.455 2.363a1.363 1.363 0 0 1-1.653-1.653l2.363-9.455c.06-.24.184-.459.359-.633zm17.307.732.707.707-.707-.707-3.531 3.53-9.02-9.02 3.531-3.53a1.364 1.364 0 0 1 1.929 0l7.09 7.091.708-.707-.707.707a1.364 1.364 0 0 1 0 1.929Z"
  })));
};
export default SvgIcoPencil;